import { Component, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class LoadingComponent {

  @Input() loadingText: string = 'Hold on, we\'re getting things ready...';
  @Input() height: string = '400px';

  constructor() { }

}
